import apiCall from 'apps/investcore/apiCalls/provinces';
import {
  DynamicFilterForm,
  FilterFieldConfig,
} from 'common/dynamic-filter-form';
import { DetailPage, EditPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import ItemForm from './form';

const filterFields: FilterFieldConfig[] = [
  {
    name: 'address_version',
    type: 'select',
    label: 'Version',
    options: [
      { value: 'v1', label: 'v1 (Old)' },
      { value: 'v2', label: 'v2 (New)' },
    ],
  },
];

const ProvinceFilterForm = props => (
  <DynamicFilterForm fields={filterFields} {...props} />
);

export const ProvinceListPage = () => (
  <ListPage
    title="All Provinces"
    description="All Provinces (for both old and new address version)"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={ProvinceFilterForm}
  />
);

export const ProvinceDetailPage = props => (
  <DetailPage
    title="Province"
    apiCall={apiCall}
    listUrl={`/admin/provinces`}
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ editEnabled: true }}
    {...props}
  />
);

export const ProvinceEditPage = props => (
  <EditPage
    title="Province"
    apiCall={apiCall}
    listUrl={`/admin/provinces`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);
